import { Injectable, inject } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnterpriseDto } from 'lib';

@Injectable({
    providedIn: 'root'
})
export class EnterpriseGroupService {
    private http = inject(HttpClient);

    private baseUrl = environment.apiUrl + '/api/v1/enterprise';

    createEnterprise(enterpriseDto: Partial<EnterpriseDto>): Observable<EnterpriseDto> {
        return this.http.post<EnterpriseDto>(`${this.baseUrl}`, enterpriseDto);
    }

    getEnterprise(id: number): Observable<EnterpriseDto> {
        return this.http.get<EnterpriseDto>(`${this.baseUrl}/${id}`);
    }
}
